import { Delete } from "@mui/icons-material";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import MaterialReactTable from "material-react-table";
import React, { useCallback, useMemo, useState } from "react";
//Import Material React Table Translations
import { MRT_Localization_ES } from "material-react-table/locales/es";
//Icons Imports
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { ThemeProvider, darken } from "@mui/material";
import ModalConfirmacion from "../modales/ModalConfirmacion";

const TablaSubperiodo = ({
  columnas,
  lineas,
  titulo,
  handleOpen,
  funcionConfirmacion,
  acciones = false,
  accionAgregar = false,
  accionEliminar = false,
  accionConfirmar = false,
}) => {
  const [data, setData] = useState(lineas);
  const columns = useMemo(() => columnas, [data]);
  const [open, setOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [texto, setTexto] = React.useState('')
  const [tipoDeBoton, setTipoDeBoton] = React.useState('')
  const [id, setId] = React.useState('')
  const [estado, setEstado] = useState('')

  React.useEffect(() => {
    if (lineas.length > 0) {
      setData(lineas);
    } else {
      setData([]);
    }
  }, [lineas, columnas]);

  const openModal = (row) => {
    var id = row.getValue("id");
    handleOpen(id, lineas);
  };

  const openModalNew = () => {
    try {
      handleOpen();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteRow = useCallback((row, estado) => {
      setOpen(true);
      setRowToDelete(row.original.id);
      setEstado(estado)
      setTexto('¿Estás seguro que quieres declinar esta opción?');
      setTipoDeBoton('Declinar')
    },
    [data]
  );

  const handleConfirtRow = useCallback( (row, estado) => {
      setOpen(true);
      setRowToDelete(row.original.id);
      setEstado(estado)
      setTexto('¿Estás seguro que deseas confirmar esta opción?');
      setTipoDeBoton('Confirmar')
    },
    [data]
  );

  const handleClose = (confirm) => {
    console.log(estado)
    setOpen(false);
    if (confirm && rowToDelete) {
      funcionConfirmacion(rowToDelete, estado);
    }
  };

  return (
    <>
      <ThemeProvider>
        <MaterialReactTable
          muiTablePaginationProps={{
            rowsPerPageOptions: [5, 10],
            showFirstLastPageButtons: false,
          }}
          onPaginationChange={setPagination}
          state={{ pagination }}
          columns={columns}
          data={data}
          muiTablePaperProps={{
            elevation: 0,
            sx: (theme) => ({
              borderRadius: "0",
              border: darken(theme.palette.background.default, 0.1),
              bgcolor: theme.palette.mode == "dark" ? "#24292e" : "#bdbdbd",
            }),
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor:
                  theme.palette.mode == "dark" ? "#24292e" : "#bdbdbd",
              },
            }),
          }}
          enableFullScreenToggle={false}
          enableColumnFilterModes={true}
          enableColumnOrdering={true}
          enableColumnActions={true}
          enableColumnFilters={true}
          enableSorting={true}
          enableColumnResizing
          columnResizeMode="onChange"
          enablePinning
          enableRowActions={acciones}
          enableStickyHeader
          initialState={{
            showColumnFilters: false,
            columnVisibility: { id: false },
            density: "compact",
          }}
          positionToolbarAlertBanner="bottom"
          localization={MRT_Localization_ES}
          defaultColumn={{
            maxSize: 400,
            minSize: 40,
          }}
          muiTableContainerProps={{
            sx: { maxWidth: "95vw", fontSize: { xs: ".7rem", md: "7rem" } },
          }}
          enableEditing={false}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <Tooltip
                arrow
                placement="left"
                title={<Typography sx={{ fontSize: "0.8rem" }}>Ver</Typography>}
              >
                <IconButton>
                  <VisibilityIcon onClick={() => openModal(row)} />
                </IconButton>
              </Tooltip>
              {accionEliminar ? (
                <Tooltip
                  arrow
                  placement="right"
                  title={
                    <Typography sx={{ fontSize: "0.8rem" }}>
                      Eliminar
                    </Typography>
                  }
                >
                  <IconButton
                    color="error"
                    sx={{ color: "#d32f2f" }}
                    onClick={() => handleDeleteRow(row, '100000001')} 
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              ) : null}
              {accionConfirmar ? (
                <Tooltip
                  arrow
                  placement="left"
                  title={
                    <Typography sx={{ fontSize: "0.8rem" }}>
                      Confirmar
                    </Typography>
                  }
                >
                  <IconButton
                    onClick={() => handleConfirtRow(row, '100000000')}
                  >
                    <CheckCircleRoundedIcon color="success" />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <>
              {accionAgregar ? (
                <Button
                  color="secondary"
                  onClick={() => openModalNew()}
                  variant="contained"
                >
                  <PlaylistAddIcon />
                </Button>
              ) : null}
              <Typography variant="subtitle" p="2px">
                {titulo}
              </Typography>
            </>
          )}
        />
      </ThemeProvider>
      <ModalConfirmacion open={open} handleClose={handleClose} texto={texto} tipo={tipoDeBoton} id={id} />
    </>
  );
};

export default React.memo(TablaSubperiodo);